import { apiClient } from './client';

export interface StoryDraft {
  id: string;
  mediaFileId: string | null;
  caption: string | null;
  textOverlay: string | null;
  privacy: 'ALL' | 'CONTACTS' | 'NOBODY';
  musicTrackId: string | null;
  scheduledFor: string | null;
  createdAt: string;
  updatedAt: string;
}

export const draftsApi = {
  async list() {
    const r = await apiClient.get('/api/story-drafts');
    return r.data.items as StoryDraft[];
  },
  async upsert(body: Partial<StoryDraft> & { mediaFileId?: string | null }) {
    const r = await apiClient.post('/api/story-drafts', body);
    return r.data as StoryDraft;
  },
  async remove(id: string) {
    await apiClient.delete(`/api/story-drafts/${id}`);
  },
  async publish(id: string) {
    const r = await apiClient.post(`/api/story-drafts/${id}/publish`);
    return r.data;
  },
};
